export default "__VITE_ASSET__B15aee$f__"